import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Clinic, ClinicService, Invite, InvitesService, InviteStatus } from "@meddatacore/shared";

@Component({
  selector: 'app-invite-form',
  templateUrl: './invite-form.component.html',
  styleUrls: ['./invite-form.component.scss']
})
export class InviteFormComponent implements OnInit {
  invite: Invite;
  clinic: Clinic;
  InviteStatus = InviteStatus;

  constructor(
    private route: ActivatedRoute,
    private invitesService: InvitesService,
    private clinicService: ClinicService,
    private router: Router) {
  }

  ngOnInit(): void {
    const inviteId = this.route.snapshot.paramMap.get("id");

    this.loadInvite(inviteId);
  }

  loadInvite(id: string) {
    this.invitesService.getInvite(id)
      .subscribe(invite => {
        this.invite = invite;
        this.loadClinic(invite.tenantId)
      });
  }
  loadClinic(id: string) {
    this.clinicService.get(id).subscribe(a => {
      this.clinic = a;
    })
  }
  accept() {
    this.invitesService.accept(this.invite.id)
      .subscribe(() => {
        this.router.navigate(['/invites']);
      });
  }

  refuse() {
    this.invitesService.refuse(this.invite.id)
      .subscribe(() => {
        this.router.navigate(['/invites']);
      });
  }
}
